import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { Toaster } from "sonner";
import { spend2ConnectTheme } from "../theme/spend2ConnectTheme";
import { GlobalApiMessages } from "../components/feedback/GlobalApiMessages";

export function AppProviders({ children }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30000,
            retry: 1,
            refetchOnWindowFocus: false,
          },
        },
      }),
  );

  return (
    <ThemeProvider theme={spend2ConnectTheme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        {children}
      <GlobalApiMessages />
      </QueryClientProvider>
    </ThemeProvider>
  );
}
